<template>
  <BaseDropdown
    v-bind="$attrs"
    v-on="$listeners"
    :options="options"
    :styleConfig="styleConfig"
  >
    <template v-slot:placeholder>
      <GoogleMaterialIconPrimary
        :color="iconColor"
        :content="content"
        :disabled="disabled"
        :fontSize="iconFontSize"
        :style="style.icon"
      />
    </template>
    <template v-slot:selection>
      <GoogleMaterialIconPrimary
        :color="iconColor"
        :content="content"
        :disabled="disabled"
        :fontSize="iconFontSize"
        :style="style.icon"
      />
    </template>
    <template v-slot:option="props">
      <TextNavItemSecondary
        :selected="props.option.selectedFunction($route.path)"
        :to="props.option.to"
        @mousedown-item="props.option.onClick"
      >
        {{ props.label }}
        <GoogleMaterialIconPrimary
          v-if="props.option.locked"
          :content="'lock'"
          :fontSize="styleVariable.icon.lock.fontSize"
          :style="style.iconLock"
        />
      </TextNavItemSecondary>
    </template>
  </BaseDropdown>
</template>

<script>
  import BaseDropdown from '@base/v2/base-dropdown'
  import GoogleMaterialIconPrimary from '@modules/v2/icon/google-material-icon-primary'
  import TextNavItemSecondary from '@modules/v2/text/text-nav-item-secondary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'NavigationDropdownPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change',
    },
    components: {
      BaseDropdown,
      GoogleMaterialIconPrimary,
      TextNavItemSecondary,
    },
    props: {
      vmodelValue: {
        type: [Number, Object, String],
        reuqired: false,
        default: null,
      },
      content: {
        type: String,
        required: false,
        defualt: '',
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      iconColor: {
        type: String,
        required: false,
        default: null,
      },
      iconFontSize: {
        type: String,
        required: false,
        default: FontStyle.size.lg,
      },
      options: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        selectedOptionId: this.vmodelValue,
        styleVariable: {
          icon: {
            lock: {
              fontSize: '16px',
            },
          },
        },
        style: {
          icon: {},
          iconLock: {
            margin: `0 0 0 ${Layout.space.xs}`,
          },
        },
        styleConfig: {
          actionSymbol: {},
          container: {},
          dropdown: {
            borderRadius: Layout.space.sm,
            padding: `${Layout.space.sm} 0`,
            margin: `${Layout.space.sm} 0 0 0`,
            minWidth: '158px',
          },
          dropdownList: {
            overflow: 'none',
          },
          expandSymbol: {},
          option: {
            padding: `0 ${Layout.space.md}`,
          },
          placeholder: {
            alignItems: 'center',
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            display: 'flex',
            justifyContent: 'center',
          },
          row: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            height: '32px',
            fontWeight: {
              '': FontStyle.weight.md,
              selected: FontStyle.weight.xl,
            },
            width: '100%',
          },
          selectionContainer: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
          },
          selection: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
          },
          selectSymbol: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.dropdown,
        {
          backgroundColor: this.color.light1(),
          border: `solid ${this.color.dark4()}`,
          borderWidth: '1px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
        },
      );
      Object.assign(
        this.styleConfig.row,
        {
          backgroundColor: {
            '': 'transparent',
            hover: this.color.dark6(),
            active: this.color.dark6(),
            disabled: this.color.dark4(),
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
